import { Link } from 'react-router-dom';
import type { videos as VideoType } from '@/mocks/videos';

interface VideoCardProps {
  video: typeof VideoType[number];
  size?: 'normal' | 'large';
}

export default function VideoCard({ video, size = 'normal' }: VideoCardProps) {
  return (
    <Link
      to={`/article/${video.id}`}
      className="group block cursor-pointer"
    >
      <div className={`relative overflow-hidden rounded-xl mb-3 ${
        size === 'large' ? 'aspect-video' : 'aspect-video'
      }`}>
        <img
          src={video.thumbnail}
          alt={video.title}
          title={`${video.title} - 果冻传媒高清视频`}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 via-transparent to-transparent"></div>
        <div className="absolute bottom-0 left-0 right-0 p-3">
          <div className="flex items-center gap-2">
            <span className="px-2 py-0.5 bg-background-50/20 backdrop-blur-sm rounded text-xs text-background-50 font-medium">
              {video.duration}
            </span>
            {video.episodes > 0 && (
              <span className="px-2 py-0.5 bg-background-50/20 backdrop-blur-sm rounded text-xs text-background-50">
                共{video.episodes}集
              </span>
            )}
          </div>
        </div>
        {video.isHot && (
          <div className="absolute top-2 left-2 px-2 py-0.5 bg-primary-500 rounded-md text-xs text-background-50 font-medium">
            热门
          </div>
        )}
        {video.isNew && (
          <div className="absolute top-2 right-2 px-2 py-0.5 bg-accent-500 rounded-md text-xs text-foreground-950 font-medium">
            新上线
          </div>
        )}
        <div className="absolute inset-0 bg-foreground-950/0 group-hover:bg-foreground-950/10 transition-colors duration-300 flex items-center justify-center">
          <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 transform group-hover:scale-100 scale-75">
            <i className="ri-play-fill text-background-50 text-xl ml-0.5"></i>
          </div>
        </div>
      </div>

      <h3 className="text-sm md:text-base font-medium text-foreground-900 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2 leading-snug">
        {video.title}
      </h3>

      <div className="flex items-center gap-3 mt-2 text-xs text-foreground-500">
        <span className="flex items-center gap-1">
          <i className="ri-eye-line"></i>
          {video.views >= 10000
            ? `${(video.views / 10000).toFixed(1)}万`
            : video.views}
        </span>
        <span className="flex items-center gap-1">
          <i className="ri-star-fill text-accent-500"></i>
          {video.rating}
        </span>
      </div>

      {video.tags && video.tags.length > 0 && (
        <div className="flex items-center gap-1.5 mt-2 flex-wrap">
          {video.tags.map((tag) => (
            <span
              key={tag}
              className="px-2 py-0.5 bg-secondary-100 text-secondary-700 rounded text-xs"
            >
              {tag}
            </span>
          ))}
        </div>
      )}
    </Link>
  );
}